import React from "react";
import { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Programs.css";
// events
import event1 from "../../Images/events/Month of October 2025/Biodiversity and Wildlife Studies 24.10.2025/WhatsApp Image 2025-10-24 at 5.13.06 PM.jpeg";
import event2 from "../../Images/events/Month of October 2025/Career Guidance 14.10.2025 (Patseoni & Chhura)/WhatsApp Image 2025-10-15 at 2.11.37 PM (1).jpeg";
import event3 from "../../Images/events/Month of October 2025/Diwali Milam 18.10.2025/WhatsApp Image 2025-10-17 at 7.11.06 PM.jpeg";
import event4 from "../../Images/events/Month of October 2025/Guest Lecture on “Research Methods and Innovative Practices in the Context of NEP 2020” 9 & 10 Oct 2025/WhatsApp Image 2025-10-15 at 2.23.56 PM (2).jpeg";
import event5 from "../../Images/events/Month of October 2025/International Women Day 15.10.2025/WhatsApp Image 2025-10-14 at 12.49.38 PM.jpeg";
import event6 from "../../Images/events/Month of October 2025/Road safety Awareness Campaign 2025 (25.10.2025)/WhatsApp Image 2025-10-24 at 6.43.40 PM.jpeg";
import event7 from "../../Images/events/Month of October 2025/Science Club 12.10.2025/WhatsApp Image 2025-10-13 at 7.03.25 AM.jpeg";
import event8 from "../../Images/events/Month of October 2025/World Animal Day 07.10.2025/WhatsApp Image 2025-10-07 at 4.45.25 PM.jpeg";
import event9 from "../../Images/events/Month of October 2025/World Food Day 16.10.2025/WhatsApp Image 2025-10-16 at 12.26.53 PM.jpeg";
import event10 from "../../Images/events/Month of October 2025/World Girls Child Day 11.10.2025/WhatsApp Image 2025-10-11 at 9.21.06 AM.jpeg";
import event11 from "../../Images/events/Month of October 2025/World Mental Health Day 10.10.2025/WhatsApp Image 2025-10-10 at 11.15.08 AM.jpeg";
import event12 from "../../Images/events/Month of October 2025/World Space Week 09.10.2025/WhatsApp Image 2025-10-09 at 5.24.30 PM.jpeg";
import event13 from "../../Images/events/Month of September, 2025/9th Foundation day celebration/WhatsApp Image 2025-09-09 at 6.02.24 PM.jpeg";
import event14 from "../../Images/events/Month of September, 2025/Alumni Meet (Rajat Jayanti) 10.09.2025/WhatsApp Image 2025-09-10 at 3.16.38 PM.jpeg";
import event15 from "../../Images/events/Month of September, 2025/Blood Donation Camp 26.09.2025/WhatsApp Image 2025-09-26 at 8.50.05 PM.jpeg";
import event16 from "../../Images/events/Month of September, 2025/Campus Jung 2025 16.09.2025/WhatsApp Image 2025-09-13 at 7.56.34 PM.jpeg";
import event17 from "../../Images/events/Month of September, 2025/Engineers Day 15.09.2025/WhatsApp Image 2025-09-13 at 8.10.11 PM.jpeg";
import event18 from "../../Images/events/Month of September, 2025/Helmat Awarness Program 03.09.2025/WhatsApp Image 2025-09-03 at 1.10.37 PM.jpeg";
import event19 from "../../Images/events/Month of September, 2025/Hindi Pakhwada 14 to 29.09.2025/WhatsApp Image 2025-09-14 at 1.31.21 PM.jpeg";
import event20 from "../../Images/events/Month of September, 2025/Khel_17.09.2025/WhatsApp Image 2025-09-19 at 11.44.58 AM.jpeg";
import event21 from "../../Images/events/Month of September, 2025/NSS Awarness Program 29.09.2025/WhatsApp Image 2025-09-27 at 2.18.20 PM.jpeg";
import event22 from "../../Images/events/Month of September, 2025/Navratri Festival 29.09.2025/WhatsApp Image 2025-09-27 at 6.31.25 PM.jpeg";
import event23 from "../../Images/events/Month of September, 2025/Rajat Jayanti Samarosh 5 to 12 Sept,2025/WhatsApp Image 2025-09-08 at 6.27.17 PM.jpeg";
import event24 from "../../Images/events/Month of September, 2025/Seva Pakhwada 26.09.2025/WhatsApp Image 2025-09-26 at 4.58.41 PM (1).jpeg";
import event25 from "../../Images/events/Month of September, 2025/Shanti Diwas_20.09.2025/WhatsApp Image 2025-09-20 at 3.10.10 PM.jpeg";
import event26 from "../../Images/events/Month of September, 2025/Teachers Day 05.09.2025/WhatsApp Image 2025-09-05 at 9.57.47 AM.jpeg";
import event27 from "../../Images/events/Month of September, 2025/Tourism Day 26.09.2025/WhatsApp Image 2025-09-26 at 5.31.27 PM.jpeg";
import event28 from "../../Images/events/Month of September, 2025/Vishvakarma Pooja 17.09.2025/WhatsApp Image 2025-09-16 at 4.19.06 PM.jpeg";
import event29 from "../../Images/events/Month of September, 2025/Wold Ozone Day 17.09.2025/WhatsApp Image 2025-09-16 at 1.34.38 PM.jpeg";
import event30 from "../../Images/events/Month of September, 2025/World Heart Day 30.09.2025/WhatsApp Image 2025-09-29 at 4.38.40 PM.jpeg";
import event31 from "../../Images/events/Month of September, 2025/World Pharmacist Day 25.09.2025 (Health Check up)/WhatsApp Image 2025-09-25 at 12.16.26 PM.jpeg";
import event32 from "../../Images/events/Month of September, 2025/कौशल संवर्धन कार्यक्रम _23.09.2025/WhatsApp Image 2025-09-23 at 4.58.09 PM.jpeg";
import event33 from "../../Images/events/Month of October 2025/Vice Chancellor Reappointed/image (4).png";
import event34 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-15 at 8.48.50 AM.jpeg";
import event35 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-16 at 8.08.28 PM.jpeg";
import event36 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 4.38.53 PM.jpeg";
import event37 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 4.40.06 PM.jpeg";
import event38 from "../../Images/events/Month-of-November-2025/image (9).png";
import event39 from "../../Images/events/Month-of-November-2025/image (11).png";

// new letters
import newsletter1 from "../../Images/newsLetter/Newsletter December, 2024.pdf";
import newsletter2 from "../../Images/newsLetter/grooming session.pdf";

// curculars
import circular1 from "../../Images/circular/Notice & Circular 2024- 25/Admission Notice .pdf";
import circular2 from "../../Images/circular/Notice & Circular 2024- 25/Circular .pdf";
import circular3 from "../../Images/circular/Notice & Circular 2024- 25/Circular (All HODs) .pdf";
import circular4 from "../../Images/circular/Notice & Circular 2024- 25/Circular (Dr. Swamy & Dr. Biswas) .pdf";
import circular5 from "../../Images/circular/Notice & Circular 2024- 25/Circular (members of the faculty) .pdf";
import circular6 from "../../Images/circular/Notice & Circular 2024- 25/Circular (Ph.D Faculty ).pdf";
import circular7 from "../../Images/circular/Notice & Circular 2024- 25/Circular for Board of Examination committee meeting .pdf";
import circular8 from "../../Images/circular/Notice & Circular 2024- 25/Circular for rotation of HOD .pdf";
import circular9 from "../../Images/circular/Notice & Circular 2024- 25/Court Notice .pdf";
import circular10 from "../../Images/circular/Notice & Circular 2024- 25/Induction Program Notice - 2024- 25.pdf";
import circular11 from "../../Images/circular/Notice & Circular 2024- 25/Induction Program_(05.08.2024)_Job Distribution_20240802_165502.pdf";
import circular12 from "../../Images/circular/Notice & Circular 2024- 25/Induction Program_(05.08.2024)_Time line__20240802_165633.pdf";
import circular13 from "../../Images/circular/Notice & Circular 2024- 25/Induction Program_20240801_163741.pdf";
import circular14 from "../../Images/circular/Notice & Circular 2024- 25/Notice  (Sports) .pdf";
import circular15 from "../../Images/circular/Notice & Circular 2024- 25/Notice _20240621.pdf";
import circular16 from "../../Images/circular/Notice & Circular 2024- 25/Notice .jpg";
import circular17 from "../../Images/circular/Notice & Circular 2024- 25/Notice (01.06.2025).pdf";
import circular18 from "../../Images/circular/Notice & Circular 2024- 25/NOTICE (1).jpg";
import circular19 from "../../Images/circular/Notice & Circular 2024- 25/Notice (1).pdf";
import circular20 from "../../Images/circular/Notice & Circular 2024- 25/Notice (3).pdf";
import circular21 from "../../Images/circular/Notice & Circular 2024- 25/Notice (4).pdf";
import circular22 from "../../Images/circular/Notice & Circular 2024- 25/Notice (5).pdf";
import circular23 from "../../Images/circular/Notice & Circular 2024- 25/Notice (28.12.2024).pdf";
import circular24 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Appointment of PIO).pdf";
import circular25 from "../../Images/circular/Notice & Circular 2024- 25/Notice (attending one day seminar).pdf";
import circular26 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Cultural Program on 15.08.2024).pdf";
import circular27 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Diwali) .pdf";
import circular28 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Even Semester Exam - 2025).pdf";
import circular29 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Good Friday).pdf";
import circular30 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Google form report) .pdf";
import circular31 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Guru Nanak Jayanti) .pdf";
import circular32 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday of Eid-Milad-un-Nabi).pdf";
import circular33 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday of Gandhi Jayanti).pdf";
import circular34 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday of Mahanavami & Dussehra).pdf";
import circular35 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday of Teej Festival).pdf";
import circular36 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday) .pdf";
import circular37 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Holiday).pdf";
import circular38 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Id-Ul Fitr) .pdf";
import circular39 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Scholarship) .pdf";
import circular40 from "../../Images/circular/Notice & Circular 2024- 25/Notice (Yoga) .pdf";
import circular41 from "../../Images/circular/Notice & Circular 2024- 25/Notice for ABC ID .pdf";
import circular42 from "../../Images/circular/Notice & Circular 2024- 25/Notice for commencement of intermediate classes - 2024- 25.pdf";
import circular43 from "../../Images/circular/Notice & Circular 2024- 25/Notice for ID Card .pdf";
import circular44 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Independence Day, 2024 .pdf";
import circular45 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Induction Program & Orientation Program .pdf";
import circular46 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Induction Program & Orientation Program (1).pdf";
import circular47 from "../../Images/circular/Notice & Circular 2024- 25/Notice for NEP Orientation and sensitization Program .pdf";
import circular48 from "../../Images/circular/Notice & Circular 2024- 25/Notice for PIO Appointment.pdf";
import circular49 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Raksha Bandhan.pdf";
import circular50 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Semester Mode Students .pdf";
import circular51 from "../../Images/circular/Notice & Circular 2024- 25/Notice for University Foundation Day .pdf";
import circular52 from "../../Images/circular/Notice & Circular 2024- 25/Notice for Yearly mode students .pdf";
import circular53 from "../../Images/circular/Notice & Circular 2024- 25/Notice of Inchare Admission.pdf";
import circular54 from "../../Images/circular/Notice & Circular 2024- 25/Notification (Exam Cell) .pdf";
import circular55 from "../../Images/circular/Notice & Circular 2024- 25/Odd semester exam notification .pdf";
import circular56 from "../../Images/circular/Notice & Circular 2024- 25/Office Order (DSW appoint).pdf";
import circular57 from "../../Images/circular/Notice & Circular 2024- 25/Office order for Dean_Faculty of Sciences.pdf";
import circular58 from "../../Images/circular/Notice & Circular 2024- 25/Office order for DSW.pdf";
import circular59 from "../../Images/circular/Notice & Circular  2025- 26/WhatsApp Image 2025-10-30 at 10.54.17 AM.jpeg";
import circular60 from "../../Images/circular/Notice & Circular  2025- 26/Circular (Admission In-charge).pdf";
import circular61 from "../../Images/circular/Notice & Circular  2025- 26/Circular (non-teaching) .pdf";
import circular62 from "../../Images/circular/Notice & Circular  2025- 26/Independence Day Notice .pdf";
import circular63 from "../../Images/circular/Notice & Circular  2025- 26/Notice (6).pdf";
import circular64 from "../../Images/circular/Notice & Circular  2025- 26/Notice (7).pdf";
import circular65 from "../../Images/circular/Notice & Circular  2025- 26/Notice (Bus) .pdf";
import circular66 from "../../Images/circular/Notice & Circular  2025- 26/Notice (Diwali) (1).pdf";
import circular67 from "../../Images/circular/Notice & Circular  2025- 26/Notice (HaritalikaTeej).pdf";
import circular68 from "../../Images/circular/Notice & Circular  2025- 26/Notice (Holiday) (1).pdf";
import circular69 from "../../Images/circular/Notice & Circular  2025- 26/Notice (Holiday) (2).pdf";
import circular70 from "../../Images/circular/Notice & Circular  2025- 26/Notice (Readmission & Form fill up) .pdf";
import circular71 from "../../Images/circular/Notice & Circular  2025- 26/Notice_14.08.2025_Shri Krishna Janmasthami.pdf";
import circular72 from "../../Images/circular/Notice & Circular  2025- 26/WhatsApp Image 2025-11-03 at 2.06.09 PM.jpeg";
import circular73 from "../../Images/circular/Notice & Circular  2025- 26/WhatsApp Image 2025-11-19 at 12.47.40 PM.jpeg";
import circular74 from "../../Images/circular/Notice & Circular  2025- 26/constitution day.jpeg";
import circular75 from "../../Images/circular/Notice & Circular  2025- 26/soft skill.jpeg";
const NewsEventsCircular = () => {
    const data = [
        {
            title: "News Letters",
            type: "pdf",
            items: [
                {
                    name: "December 2024 Newsletter",
                    pdf: newsletter1,
                    date: "2025-01-18"
                },
                {
                    name: "Grooming Session",
                    pdf: newsletter2,
                    date: "2025-10-31"
                },
            ],
        },
        {
            title: "Events",
            type: "event",
            items: [
                { name: "Biodiversity and Wildlife Studies", img: event1, date: "2025-10-24" },
                { name: "Career Guidance (Patseoni & Chhura)", img: event2, date: "2025-10-15" },
                { name: "Diwali Milam", img: event3, date: "2025-10-18" },
                { name: "Guest Lecture", img: event4, date: "2025-10-09 & 2025-10-10" },
                { name: "International Women Day", img: event5, date: "2025-10-15" },
                { name: "Road safety Awareness Campaign", img: event6, date: "2025-10-25" },
                { name: "Science Club", img: event7, date: "2025-10-13" },
                { name: "World Animal Day", img: event8, date: "2025-10-07" },
                { name: "World Food Day", img: event9, date: "2025-10-16" },
                { name: "World Girls Child Day", img: event10, date: "2025-10-11" },
                { name: "World Mental Health Day", img: event11, date: "2025-10-10" },
                { name: "World Space Week", img: event12, date: "2025-10-09" },
                { name: "9th Foundation day", img: event13, date: "2025-09-09" },
                { name: "Alumni Meet", img: event14, date: "2025-09-10" },
                { name: "Blood Donation Camp", img: event15, date: "2025-09-26" },
                { name: "Campus Jung", img: event16, date: "2025-09-16" },
                { name: "Engineers Day", img: event17, date: "2025-09-15" },
                { name: "Helmat Awarness Program", img: event18, date: "2025-09-03" },
                { name: "Hindi Pakhwada", img: event19, date: "2025-09-29" },
                { name: "Khel", img: event20, date: "2025-09-17" },
                { name: "NSS Awarness Program", img: event21, date: "2025-09-29" },
                { name: "Navratri Festival", img: event22, date: "2025-09-29" },
                { name: "Rajat Jayanti Samarosh", img: event23, date: "2025-09-05 to 2025-09-12" },
                { name: "Seva Pakhwada", img: event24, date: "2025-09-26" },
                { name: "Shanti Diwas", img: event25, date: "2025-09-20" },
                { name: "Teachers Day", img: event26, date: "2025-09-05" },
                { name: "Tourism Day", img: event27, date: "2025-09-26" },
                { name: "Vishvakarma Pooja", img: event28, date: "2025-09-17" },
                { name: "World Ozone Day", img: event29, date: "2025-09-17" },
                { name: "World Heart Day", img: event30, date: "2025-09-30" },
                { name: "World Pharmacist Day", img: event31, date: "2025-09-25" },
                { name: "कौशल संवर्धन कार्यक्रम", img: event32, date: "2025-09-23" },
                { name: "Vice Chancellor Reappointed", img: event33, date: "2025-10-31" },
                { name: "कौशल संवर्धन कार्यक्रम", img: event34, date: "2025-09-23" },
                { name: "Vice Chancellor Reappointed", img: event35, date: "2025-10-31" },
                { name: "Pharmacy Week", img: event36, date: "2025-11-17" },
                { name: "Quiz competition", img: event37, date: "2025-11-17" },
                { name: "Soft Skill Life Skill", img: event38, date: "2025-11-22" },
                { name: "INDUSTRIAL VISIT", img: event39, date: "2025-11-21" },
            ],
        },
        {
            title: "Circulars & Notices",
            type: "pdf",
            items: [
                { name: "Admission Notice", pdf: circular1, date: "2024-02-26" },
                { name: "Circular", pdf: circular2, date: "2025-02-28" },
                { name: "Circular (All HODs)", pdf: circular3, date: "2025-02-06" },
                { name: "Circular (Dr. Swamy & Dr. Biswas)", pdf: circular4, date: "2025-02-06" },
                { name: "Circular (members of the faculty)", pdf: circular5, date: "2025-02-06" },
                { name: "Circular (Ph.D Faculty )", pdf: circular6, date: "2025-02-06" },
                { name: "Circular for Board of Examination", pdf: circular7, date: "2024-12-05" },
                { name: "Circular for rotation of HOD", pdf: circular8, date: "2025-06-11" },
                { name: "Court Notice", pdf: circular9, date: "2024-09-24" },
                { name: "Induction Program Notice", pdf: circular10, date: "2024-07-31" },
                { name: "Induction Job Distribution", pdf: circular11, date: "2024-08-02" },
                { name: "Induction Program Time line", pdf: circular12, date: "2024-08-02" },
                { name: "Induction Program", pdf: circular13, date: "2024-08-01" },
                { name: "Notice (Sports)", pdf: circular14, date: "2024-08-28" },
                { name: "Notice 30.05.2025", pdf: circular15, date: "2025-05-30" },
                { name: "Notice ", pdf: circular16, date: "2024-10-04" },
                { name: "Notice 01.06.2025", pdf: circular17, date: "2025-06-01" },
                { name: "NOTICE (1)", pdf: circular18, date: "2025-03-26" },
                { name: "Notice (1)", pdf: circular19, date: "2024-07-19" },
                { name: "Notice (3)", pdf: circular20, date: "2024-09-10" },
                { name: "Notice (4)", pdf: circular21, date: "2024-10-04" },
                { name: "Notice (5)", pdf: circular22, date: "2025-06-08" },
                { name: "Notice 28.12.2024", pdf: circular23, date: "2025-01-04" },
                { name: "Notice (Appointment of PIO)", pdf: circular24, date: "2024-09-11" },
                { name: "Notice (attending seminar)", pdf: circular25, date: "2025-04-23" },
                { name: "Notice (Cultural Program)", pdf: circular26, date: "2024-08-07" },
                { name: "Notice (Diwali)", pdf: circular27, date: "2024-10-29" },
                { name: "Notice (Even Semester Exam)", pdf: circular28, date: "2025-04-25" },
                { name: "Notice (Good Friday)", pdf: circular29, date: "2025-04-17" },
                { name: "Notice (Google form report)", pdf: circular30, date: "2024-11-06" },
                { name: "Notice (Guru Nanak Jayanti)", pdf: circular31, date: "2024-11-14" },
                { name: "Notice (Holiday Eid-Milad-un-Nabi)", pdf: circular32, date: "2024-09-14" },
                { name: "Notice (Holiday of Gandhi Jayanti)", pdf: circular33, date: "2024-10-01" },
                { name: "Notice (Holiday of Dussehra)", pdf: circular34, date: "2025-10-10" },
                { name: "Notice (Holiday of Teej )", pdf: circular35, date: "2024-09-05" },
                { name: "Notice (Holiday)", pdf: circular36, date: "2025-02-25" },
                { name: "Notice (Holiday)", pdf: circular37, date: "2025-04-12" },
                { name: "Notice (Id-Ul Fitr)", pdf: circular38, date: "2025-03-29" },
                { name: "Notice (Scholarship)", pdf: circular39, date: "2025-02-08" },
                { name: "Notice (Yoga)", pdf: circular40, date: "2024-10-03" },
                { name: "Notice for ABC ID", pdf: circular41, date: "2024-06-26" },
                { name: "Notice for intermediate", pdf: circular42, date: "2024-07-23" },
                { name: "RNotice for ID Card", pdf: circular43, date: "2024-08-14" },
                { name: "Notice for Independence Day", pdf: circular44, date: "2025-08-13" },
                { name: "Notice for Induction Program", pdf: circular45, date: "2024-07-23" },
                { name: "Notice for Induction Program (1)", pdf: circular46, date: "2024-07-23" },
                { name: "Notice for NEP Orientation", pdf: circular47, date: "2024-10-09" },
                { name: "Notice for PIO Appointment", pdf: circular48, date: "2024-09-12" },
                { name: "Notice for Raksha Bandhan", pdf: circular49, date: "2024-08-17" },
                { name: "Notice for Semester Mode Students", pdf: circular50, date: "2024-07-23" },
                { name: "Notice for University Foundation ", pdf: circular51, date: "2024-09-09" },
                { name: "Notice for Yearly mode students", pdf: circular52, date: "2024-07-23" },
                { name: "Notice of Inchare Admission", pdf: circular53, date: "2024-09-12" },
                { name: "Notification (Exam Cell)", pdf: circular54, date: "2024-11-06" },
                { name: "Odd semester exam notification", pdf: circular55, date: "2025-01-02" },
                { name: "Office Order (DSW appoint)", pdf: circular56, date: "2024-09-11" },
                { name: "Office order for Dean_Faculty", pdf: circular57, date: "2024-09-12" },
                { name: "Office order for DSW", pdf: circular58, date: "2024-09-12" },
                { name: "National Unity Day", pdf: circular59, date: "2025-10-30" },
                { name: "Circular (Admission In-charge)", pdf: circular60, date: "2025-09-03" },
                { name: "Circular (non-teaching)", pdf: circular61, date: "2025-06-28" },
                { name: "Independence Day Notice", pdf: circular62, date: "2025-08-14" },
                { name: "Notice (6)", pdf: circular63, date: "2025-06-20" },
                { name: "Notice (7)", pdf: circular64, date: "2025-09-03" },
                { name: "Notice (Bus)", pdf: circular65, date: "2025-07-30" },
                { name: "Notice (Diwali) (1)", pdf: circular66, date: "2025-10-18" },
                { name: "Notice (HaritalikaTeej)", pdf: circular67, date: "2025-08-25" },
                { name: "Notice (Holiday) (1)", pdf: circular68, date: "2025-08-08" },
                { name: "Notice (Holiday) (2)", pdf: circular69, date: "2025-09-30" },
                { name: "Notice (Readmission)", pdf: circular70, date: "2025-09-03" },
                { name: "Notice Shri Krishna Janmasthami", pdf: circular71, date: "2025-08-15" },
                { name: "Student Council Election Committee", pdf: circular72, date: "2025-11-03" },
                { name: "Industrial Tour", pdf: circular73, date: "2025-11-19" },
                { name: "constitution day", pdf: circular74, date: "2025-11-18" },
                { name: "soft skill", pdf: circular75, date: "2025-11-19" },
            ],
        },
    ];

    data.forEach(section => {
        section.items.sort((a, b) => {
            // For events that may have date ranges
            const dateAString = a.date.split("&").pop().trim(); // take the last date if range exists
            const dateBString = b.date.split("&").pop().trim();

            const dateA = new Date(dateAString);
            const dateB = new Date(dateBString);

            return dateB - dateA; // latest first
        });
    });


    // Different settings for PDFs and Events
    const sliderSettingsPDF = {
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
    };

    const sliderSettingsEvent = {
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
    };

    const sliderSettingsNewsLetter = {
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
    };

    return (
        <section className="color-section ptb-50">
            <div className="container-xxl">
                <h2 className="modern-title mb-5"><span>Campus Chronicles: </span>Latest Highlights <br></br> and Campus Updates</h2>
                <div className="row gy-4">
                    {data.map((section, idx) => (
                        <div className="col-xl-4 col-md-6" key={idx}>
                            <div className="program-column h-100 text-center shadow p-3 rounded-3">
                                <h4 className="mb-3 py-3 text-white text-decoration-underline">{section.title}</h4>
                                <Slider
                                    {...(
                                        section.title === "News Letters"
                                            ? sliderSettingsNewsLetter
                                            : section.type === "event"
                                                ? sliderSettingsEvent
                                                : sliderSettingsPDF
                                    )}
                                >
                                    {section.items.map((item, i) => (
                                        <div key={i} className="program-item mb-2">
                                            {section.type === "event" ? (
                                                <div className="event-card">
                                                    <img
                                                        src={item.img}
                                                        alt={item.name}
                                                        className="event-img rounded"
                                                    />
                                                    <div className="event-info mt-3">
                                                        <h5 className="box-title text-white">{item.name}</h5>
                                                        <p className="text-white small mb-0">
                                                            {item.date}
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <a
                                                    href={item.pdf}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="pdf-card d-flex align-items-center border-bottom py-2 text-decoration-none"
                                                >
                                                    <div className="pdf-icon me-2 text-purple">
                                                        <i className="ti ti-file fs-3"></i>
                                                    </div>
                                                    <div className="pdf-content text-start">
                                                        <h6 className="mb-1 text-dark">{item.name}</h6>
                                                        <p className="mb-0 explore-more">Explore More</p>
                                                    </div>
                                                </a>
                                            )}
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default NewsEventsCircular;
